import React, { useEffect } from "react";
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Mainlayout } from './layout/mainlayout';
import HomePage from './views/home/home';
import AirdropDeposit from './views/airdropDeposit/airdrop-deposit';
import ProfileDetails from './views/profile-details/profiledetails';
import Dashboard from './views/appPages/dashboard';
import MasterWallet from './views/appPages/masterWallet/masterWallet';
import UpgradeWallet from './views/appPages/upgradeWallet';
import LevelDetails from './views/appPages/levelDetails/levelDetails';

import { Toaster } from 'react-hot-toast';
import { queryClient } from './config';
import { QueryClientProvider } from 'react-query';
import StakingWallet from './views/appPages/stakingwallet/stakingwallet';
import StakingHistory from './views/appPages/stakingwallet/stakingHistory';
import StakingWalletHistory from './views/appPages/stakingwallet/stakingwalletHistory';
import RedeemWallet from './views/appPages/redeem/redeemWallet';
import { ModalContextProvider } from './contexts/ModalContext';
import ProfilePage from './views/appPages/profile';
import AboutusPage from './views/aboutus';
import FAQPage from './views/faq';
import TermsconditionsPage from './views/terms';
import PrivatePolicyPage from './views/policy';
import VerifyEmail from './views/appPages/verifyEmail';
import NotFoundPage from './views/404';
import DirectRefferals from './views/DirectRefferals';
import UpgradeTab from './views/appPages/upgradeTab';
import SwapTab from './views/appPages/redeem/swap';
import StakeWallet from './views/appPages/redeem/stakewallet';
import StakeRewards from './views/appPages/redeem/stakeRewards';
import GlobalRewards from './views/appPages/redeem/globalRewards';
import ICOReferralIncome from './views/appPages/redeem/ICOReferralIncome';
import MoveReferralIncome from './views/appPages/redeem/MoveStakeIncome';
import AutoStakeIncome from './views/appPages/redeem/AutoStakeIncome';
import FromStake from './views/appPages/redeem/fromStake';
import AirdropTab from './views/appPages/redeem/airdrop';
import WithdrawHistory from './views/appPages/masterWallet/withdrawHistory';
import SwapIncome from './views/appPages/masterWallet/SwapIncome';
import TopupComplete from './views/appPages/masterWallet/topupcompelete';
import MasterICOReferralIncome from './views/appPages/masterWallet/ICOReferralIncome';
import ReferralIncome from './views/appPages/masterWallet/referralIncom';
import TopUpIncome from './views/appPages/masterWallet/topupIncome';
import Whitepaper from './views/Whitepaper/Whitepaper';
import DisableDevtool from 'disable-devtool';
import ComingsoonPage from './views/comingSoon';
import { WagmiProvider } from 'wagmi'
import { projectId, metadata, networks, wagmiAdapter } from './lib/wagmi';
import { createAppKit } from '@reown/appkit/react'
function App() {
   // DisableDevtool()

   useEffect(() => {

      const onVisibilityChange = async () => {
         if (document.visibilityState === 'visible') {
            try {
               const response = await fetch('/meta.json', { cache: 'no-cache' });
               const data = await response.json();

               const currentVersion = data.version;
               let localVersion = localStorage.getItem('app_version');

               if (!localVersion) {
                  localStorage.setItem('app_version', currentVersion);
                  localVersion = currentVersion;
               }

               if (localVersion && localVersion !== currentVersion) {
                  localStorage.setItem('app_version', currentVersion);
                  window.location.reload(true);
               }
            } catch (err) {
               console.log("Error fetching version:", err);
            }
         }
      };

      document.addEventListener('visibilitychange', onVisibilityChange);

      return () => {
         document.removeEventListener('visibilitychange', onVisibilityChange);
      };


   }, []);
   const generalConfig = {
      projectId,
      networks,
      metadata,
      themeMode: 'dark',
      themeVariables: {
         '--w3m-accent': '#FCD535',
         '--w3m-border-radius-master': "10px",
         '--w3m-z-index': '1031',
      },
      authConnector: false

   }

   createAppKit({
      adapters: [wagmiAdapter],
      ...generalConfig,
      includeWalletIds: [
         'io.metamask',      
         'io.tokenpocket',    
       ],
      features: {
         analytics: true,
         email: false,
         socials: false,
      },
      


   })
   return (
      <WagmiProvider config={wagmiAdapter.wagmiConfig}>

         <QueryClientProvider client={queryClient}>

            <BrowserRouter>
               <ModalContextProvider>

                  <Routes>
                     <Route path='/' element={<Mainlayout />}>
                        <Route index element={<HomePage />} />
                        <Route path='/:id' element={<HomePage />} />

                        <Route path='airdrop-deposit' element={<AirdropDeposit />} />
                        <Route path='profile-details' element={<ProfileDetails />} />
                        <Route path='verifyemail/:id' element={<VerifyEmail />} />
                        <Route path='dashboard' element={<Dashboard />} />
                        <Route path='master-wallet' element={<MasterWallet />} />
                        <Route path='upgrade-wallet' element={<UpgradeWallet />} />
                        <Route path='level-details/:id' element={<LevelDetails />} />
                        <Route path='withdraw-history' element={<WithdrawHistory />} />
                        <Route path='swap-history' element={<SwapIncome />} />
                        <Route path='top-up-completion-history' element={<TopupComplete />} />
                        <Route path='master-ico-referral-income' element={<MasterICOReferralIncome />} />
                        <Route path='master-referral-income' element={<ReferralIncome />} />
                        <Route path='master-top-up-income' element={<TopUpIncome />} />


                        <Route path='whitepaper' element={<Whitepaper />} />


                        <Route path='comingsoon' element={<ComingsoonPage />} />


                        <Route path='upgradewallet-history' element={<UpgradeTab />} />
                        <Route path='direct-refferals' element={<DirectRefferals />} />
                        <Route path='swap' element={<SwapTab />} />
                        <Route path='move-to-stake-wallet' element={<StakeWallet />} />
                        <Route path='stake-rewards' element={<StakeRewards />} />
                        <Route path='global-rewards' element={<GlobalRewards />} />
                        <Route path='ico-referral-income' element={<ICOReferralIncome />} />
                        <Route path='auto-stake-income' element={<AutoStakeIncome />} />
                        <Route path='move-to-stake-income' element={<MoveReferralIncome />} />
                        <Route path='from-stake' element={<FromStake />} />
                        <Route path='air-drop' element={<AirdropTab />} />




                        <Route path='staking-wallet' element={<StakingWallet />} />
                        <Route path='staking-history/:stakeId' element={<StakingHistory />} />
                        <Route path='stakingwallet-history' element={<StakingWalletHistory />} />

                        <Route path='redeem-wallet' element={<RedeemWallet />} />
                        <Route path='profile' element={<ProfilePage />} />
                        <Route path='aboutus' element={<AboutusPage />} />
                        <Route path='faq' element={<FAQPage />} />
                        <Route path='terms' element={<TermsconditionsPage />} />
                        <Route path='privacypolicy' element={<PrivatePolicyPage />} />
                     </Route>
                     <Route path='*' element={<NotFoundPage />} />

                  </Routes>


               </ModalContextProvider>

            </BrowserRouter>
            <Toaster position='top-center' />

         </QueryClientProvider>
      </WagmiProvider>

   );
}

export default App;
